<template>
  <section>
    <AboutCollaborationsHeader />
    <AboutCollaborationsIntro />
    <AboutCollaborationsIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'AboutCollaborations',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['about-collaborations'] || {}
    }
  }
}
</script>
